<template>
    <action v-if="group.login_method !== 'saml'">
        <template slot="header">Gruppencode</template>
        <input-text v-model="code">
            Aktueller Code: {{ group.code }}
            <template slot="helper">Diesen Code müssen neue Mitarbeiter eingeben, um Mitglied der Gruppe zu werden.</template>
        </input-text>
        <template slot="action">
            <button-primary @click="submit">
                <template slot="icon"><i class="fa fa-save"></i></template> Speichern
            </button-primary>
        </template>
    </action>
</template>

<script>
import Action from "../UI/Action";
import ButtonPrimary from "../UI/ButtonPrimary";
import InputText from "../UI/InputText";

export default {
    name: "GroupCode",
    components: {InputText, ButtonPrimary, Action},
    inject: ['group'],

    data: () => ({
        code: '',
    }),

    created() {
        this.code = this.group.code;
    },

    methods: {
        submit() {
            window.axios.post(`/admin/group`, {
                code: this.code,
            })
                .then((response) => {
                    location.reload();
                })
                .catch((error) => {
                    location.reload();
                });
        }
    }
}
</script>

<style scoped>

</style>
